import { render } from "./ApplicationFormCard.vue?vue&type=template&id=980a451e"
import script from "./ApplicationFormCard.vue?vue&type=script&lang=js"
export * from "./ApplicationFormCard.vue?vue&type=script&lang=js"
script.render = render

export default script